import React from 'react'
import BaseInput from '../../General/FormsComp/Input/BaseInput'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'

const TecnicaCadastro = ({ newClient, handleInputChange }) => {
    const e1Options = [
        { id: '1', nome: 'Sim' },
        { id: '0', nome: 'Não' }
    ];

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <BaseInput
                label="Nome Responsável TI"
                name="responsavel_ti"
                value={newClient?.responsavel_ti}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="E-mail Responsável TI"
                name="email_responsavel_ti"
                value={newClient?.email_responsavel_ti}
                onChange={handleInputChange}
                type="email"
            />
            
            <BaseSelect
                label="Tec - E1"
                name="e1"
                value={newClient?.e1}
                onChange={handleInputChange}
                options={e1Options}
                placeholder="Selecione"
                valueKey="id"
                labelKey="nome"
            />
            
            <BaseInput
                label="Número Piloto"
                name="numero_piloto"
                value={newClient?.numero_piloto}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="Nome Técnico Responsável VoxCity"
                name="id_tecnico_voxcity"
                value={newClient?.id_tecnico_voxcity}
                onChange={handleInputChange}
                type="text"
            />
        </div>
    )
}

export default TecnicaCadastro
